import { atom } from 'jotai'

export const globalSettingsAtom = atom(null)
export const sitesAtom = atom([])
export const siteSlugAtom = atom(null)
export const currentSiteAtom = atom(null)
